import { Component, OnInit } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IngresoService } from '../../servicios/ingreso.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-encuesta-respuesta',
  templateUrl: './encuesta-respuesta.component.html',
  styleUrls: ['./encuesta-respuesta.component.css']
})
export class EncuestaRespuestaComponent implements OnInit {

  public mr: NgbModalRef;
  public nombreBeca: string = ""; public detBeca: string = ""; public indBeca: string = ""; public intEstadoFicha: number = 0; public estadoBeca: string = '';
  public vecGrupos = []; public vecAsignacion = []; public vecOpciones = []; public vecOtros = []; public vecGrupoOtros = []; public editaRes: boolean = true;


  public vecVerEncuesta = []; public vecVerGrupos = []; public vecVerPreguntas = []; public vecVerOpciones = []; public vecVerSubOpcion = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private alerti: AlertifyService, private modalService: NgbModal,
    private srvInsert: IngresoService, private ruta: Router) { }

  ngOnInit() {
    this.obtenerPreguntasCuestionario();
    this.vecVerEncuesta.push({
      datFecha: '', detEstado: '', detVisible: '', fltTiempo: '', intEstado: '', intIdEncuesta: '', intVisible: '', strCreado: '', strDescripcion: '', strNombre: '',
      strRecomendacion: '', strTerminos: ''
    });
  }

  async obtenerPreguntasCuestionario() {
    this.cargando.abrir();
    const resResCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(10, localStorage.getItem('localVerResp'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    if (resResCuest.resultado) {
      //
      const resCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(2, resResCuest.fichaEstudiantil[0].intEncuesta, 'na', 'na', 'na')
        .subscribe(translated => { resolve(translated) }));
      this.vecVerEncuesta = resCuest.resultado ? resCuest.fichaEstudiantil : [];
      //
      const resGrupo = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(5, resResCuest.fichaEstudiantil[0].intEncuesta, 'na', 'na', 'na')
        .subscribe(translated => { resolve(translated) }));
      this.vecVerGrupos = resGrupo.resultado ? resGrupo.fichaEstudiantil : [];
      //
      const resPreg = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(13, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerPreguntas = resPreg.resultado ? resPreg.fichaEstudiantil : [];
      //
      // this.datoEnc = resResCuest.fichaEstudiantil[0].intEncuesta; this.datoRes = resResCuest.fichaEstudiantil[0].strIdResponde;
      const resOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(12, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerOpciones = resOpc.resultado ? resOpc.fichaEstudiantil : [];
      //
      const resSubOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(14, resResCuest.fichaEstudiantil[0].intEncuesta,
        resResCuest.fichaEstudiantil[0].strIdResponde, 'na', 'na').subscribe(translated => { resolve(translated) }));
      this.vecVerSubOpcion = resSubOpc.resultado ? resSubOpc.fichaEstudiantil : [];
    }
    else
      this.ruta.navigate(["/becario"]);
    this.cargando.cerrar();
  }


  imprimirRespuestas() {
    let divToPrint = document.getElementById('divImprime').innerHTML;
    let newWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    newWindow.document.open();
    newWindow.document.write(`
        <html>
        <head>
        <title>Print tab</title>
        <style> </style>
        </head>
        <body onload="window.print();window.close()">${divToPrint}
        </body>
        </html>
        `);
    newWindow.document.close();
  }
  verModalFicha(nombModal) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA CERRAR UN MODAL
  cerrarModal() {
    this.mr.close();
  }
  //CAMBIAR EL ESTADO DE UNA RESPUESTA DE FICHA
  cambiaEstadoResponde() {
    this.alerti.confirm('Etá seguro que desea cambiar el estado de la ficha.', () => {
      this.srvInsert.registroGestionFicha(localStorage.getItem('localVerResp'), this.intEstadoFicha, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 10).subscribe(res => {
        if (res.respFicha) {
          this.alerti.success('Encuesta regitrada con éxito');
          this.cerrarModal();
          this.obtenerPreguntasCuestionario();
        }
        else
          this.alerti.error('Error inesperado vuelva a intentar más tarde');
      });
    });
  }

}
